import { ICreateJobForm, IJobResponse } from '@/Models'

const toStringArray = (value?: string) =>
  value
    ?.replace(/\r\n/g, '\n')
    .split('\n')
    .map((item) => item.trim())
    .filter(Boolean) ?? []

export const mapJobToForm = (job: IJobResponse): ICreateJobForm => ({
  jobTitle: job.title,
  aboutRole: job.description,
  department: job.department,
  location: job.location,
  country: job.country,
  employmentType: job.employmentType,
  minimumExperienceYears: job.minimumExperienceYears,

  responsibility: job.details?.responsibilities?.join('\n') ?? '',
  requirement: job.details?.requirements?.join('\n') ?? '',
  skills: job.details?.skills?.join('\n') ?? '',

  workArrangement: '',
  numberOfOpenings: '',
  hiringManager: '',
  recruiter: '',
  applicationDeadline: '',
  aboutTradegrid: '',
  customQuestions: [],
})

export const mapFormToPayload = (data: ICreateJobForm) => ({
  title: data.jobTitle,
  description: data.aboutRole,
  department: data.department,
  location: data.location,
  country: data.country,
  employmentType: data.employmentType,
  minimumExperienceYears: data.minimumExperienceYears,

  details: {
    responsibilities: toStringArray(data.responsibility),
    requirements: toStringArray(data.requirement),
    skills: toStringArray(data.skills),
  },

  // requireCoverLetter: true,
  // isActive: true,
  additionalInfo: {},
  // status: 'OPEN',
})
